import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import style from "css/signup/signupVerify.module.css";
import SEOMeta from "component/app/SEOMeta";

function SignUpVerify() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = location.state?.email;

  useEffect(() => {
    if (!email) {
      navigate("/signup", { replace: true });
    }
  }, [email, navigate]);

  if (!email) return null;

  const handleResend = () => {
    navigate("/signup", { replace: true });
  };

  return (
    <div className={style.page}>
      <SEOMeta
        title={t("signup.verify.seo.title")}
        description={t("signup.verify.seo.description")}
        keywords={t("signup.verify.seo.keywords")}
      />
      <div className={style.content}>
        <img
          className={style.icon}
          src={`${process.env.REACT_APP_CLIENT_URL}img/signup/email_send.svg`}
          alt=""
        />
        <h1 className={style.title}>{t("signup.verify.title")}</h1>
        <p className={style.message}>
          <Trans
            i18nKey="signup.verify.message"
            values={{ email }}
            components={{
              mail: <span className={style.email} />,
              brm: <br className={style.mobileBr} />,
              br: <br />,
            }}
          />
        </p>
        <button
          type="button"
          className={style.resendBtn}
          onClick={handleResend}
        >
          {t("signup.verify.resend")}
        </button>
      </div>
    </div>
  );
}

export default SignUpVerify;
